import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  ACTIVITY_BUILDER_DRAWER_WIDTH,
  ACTIVITY_BUILDER_HEADER_TOOLBAR_Z_INDEX,
} from './activity-builder.constants';
import { LAYOUT_HEADER_HEIGHT } from 'approot/shared/layout/layout.styles';
import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { green2 } from 'approot/shared/styles/colours.style';
import { spacing4 } from 'approot/shared/styles/spacing.style';

type HeaderToolbarProps = {
  $isActive: boolean;
};
export const HeaderToolbar = styled.div<HeaderToolbarProps>`
  left: 0;
  position: fixed;
  right: ${({ $isActive }) =>
    rem($isActive ? ACTIVITY_BUILDER_DRAWER_WIDTH : 0)};
  top: ${rem(LAYOUT_HEADER_HEIGHT)};
  z-index: ${ACTIVITY_BUILDER_HEADER_TOOLBAR_Z_INDEX};
`;

export const HeaderToolbarPlaceholder = styled.div`
  overflow: hidden;
`;

type ActivityBuilderUpdateStatusProps = {
  $isUpdating: boolean;
};
export const ActivityBuilderUpdateStatus = styled(
  BadgeSmallStyled
)<ActivityBuilderUpdateStatusProps>`
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  ${flexCentreAlignCss}
  gap: ${rem(spacing4)};

  ${({ $isUpdating }) =>
    !$isUpdating
      ? `
      background-color: ${green2};
    `
      : `
      svg {
        animation: rotation 1s linear infinite;
      }
  `}
`;
